"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookieUntil = exports.setCookieByJwtExpire = exports.setCookie = exports.getCookie = exports.exportFile = exports.deleteCookie = exports.deleteAllCookies = exports.checkLogin = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _domain = require("./domain");
var _jwt = require("./jwt");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 刪除單一 cookie
 * @param {string} cname
 */
const deleteCookie = cname => {
  document.cookie = "".concat(cname, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/").concat((0, _domain.getCookieDomainPart)());
};

/**
 * 清掉當前父網域底下所有 cookie
 */
exports.deleteCookie = deleteCookie;
const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    deleteCookie(name.trim());
  }
};

/**
 * 讀取 cookie
 * @param {string} name
 * @returns {string|null}
 */
exports.deleteAllCookies = deleteAllCookies;
const getCookie = name => {
  const v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
};
exports.getCookie = getCookie;
const checkLogin = cookieLoginName => {
  const gettoken = getCookie(cookieLoginName);
  if (gettoken) {
    return gettoken;
  }
  return "";
};

/** token 沒帶 exp 時的保底有效天數 */
exports.checkLogin = checkLogin;
const COOKIE_FALLBACK_DAYS = 1;

/**
 * 寫入 cookie 並指定到期時間
 * @param {string} cname
 * @param {string} cvalue
 * @param {Date|null} expireDate 傳 null 寫成 session cookie（關閉瀏覽器即失效）
 */
const setCookieUntil = (cname, cvalue, expireDate) => {
  const expires = expireDate ? "expires=".concat(expireDate.toUTCString(), ";") : "";
  document.cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, "path=/").concat((0, _domain.getCookieDomainPart)());
};

/**
 * 寫入 cookie
 * @param {string} cname
 * @param {string} cvalue
 * @param {number} [exdays] 有效天數，沒給的話預設 1 天
 */
exports.setCookieUntil = setCookieUntil;
const setCookie = function (cname, cvalue) {
  let exdays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : COOKIE_FALLBACK_DAYS;
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  setCookieUntil(cname, cvalue, d);
};

/**
 * 依 JWT 自己的 exp 寫入 cookie，讓 cookie 的生命週期跟著 token 走
 *
 * token 效期由發證方（Nani Club / OneClub）決定且會調整，前端不寫死天數。
 * 拿不到 exp 時才退回 COOKIE_FALLBACK_DAYS。
 * @param {string} cname
 * @param {string} cvalue 實際寫進 cookie 的值，不一定等於 jwt 本身
 * @param {string} jwt 用來讀 exp 的 token
 */
exports.setCookie = setCookie;
const setCookieByJwtExpire = (cname, cvalue, jwt) => {
  const expireDate = (0, _jwt.getJwtExpireDate)(jwt);
  if (!expireDate) {
    setCookie(cname, cvalue, COOKIE_FALLBACK_DAYS);
    return;
  }
  setCookieUntil(cname, cvalue, expireDate);
};
exports.setCookieByJwtExpire = setCookieByJwtExpire;
const exportFile = async (url, method, payload) => {
  (0, _axios.default)({
    url,
    method: method || "get",
    data: payload,
    responseType: "blob"
  }).then(res => {
    const fileName = decodeURI(res.headers["content-disposition"].replace(/\w+;filename=(.*)/, "$1")).split("UTF-8''")[1];
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  });
};
exports.exportFile = exportFile;